export const getFilings = (planTypes: string[]) =>
	planTypes
		.map((planType) => {
			if (planType == 'Pension') return '5500 Signor – Retirement Plan';
			if (planType == 'Health & Welfare') return '5500 Signor – H&W Plan';
		})
		.filter(Boolean);
